import _ from 'lodash';
import { uniqByKey } from '../utils';
import CONSTANTS from '../constants';
import { RPM_ALERT_QUEUE_ROUTE } from '../constants/other';
import {
    prepareRpmAlertQueueItems,
    resolveRpmAlertQueueTotalItems,
} from '../utils/rpmAlertQueueUtils';

const {
    FETCH_LOCATIONS_SUCCESS,
    FETCH_CALL_LOG_CODES_SUCCESS,
    FETCH_ORGS_SUCCESS,
    FETCH_QUEUE_REQUEST,
    FETCH_QUEUE_SUCCESS,
    FETCH_QUEUE_FAILURE,
    SEARCH_PATIENTS_SUCCESS,
    SEARCH_PATIENTS_FAILURE, 
    RESET_SEARCH_RESULE,
    ACTIVE_USER_RECEIVED,
    ON_TEAM_SELECTED,
    ON_CLINICIAN_SELECTED,
    MYQUEUE_COUNTS_RECEIVED,
    ALLPATIENTS_COUNTS_RECEIVED,
    RPM_ADDON_STATUSES_RECEIVED,
    RPM_DEVICE_TYPES_RECEIVED,
    SET_RPM_DEVICE_TYPE_FILTER,
    SET_RPM_ALERT_SEVERITY_FILTER,
    SET_RPM_THRESHOLD_CHART_CONTEXT,
    CLEAR_RPM_THRESHOLD_CHART_CONTEXT,

} = CONSTANTS;

const initialState = {
    organizations: [],
    locations: [],
    providers: [],
    callLogCodes: [],
    pageSize: 15,
    orgId: null,
    locationId: null,
    providerId: null,
    showFilters: false,
	showSort: false,
	sortBy: null,
    currentQueue: 'search',
    rpmenrollment:[],
    rpmenrollmentMeta: {},
    unverified: [],
    unverifiedMeta: {},
    apcmunverified: [],
    apcmunverifiedMeta: {},
    rpmunverified: [],
    rpmunverifiedMeta: {},
    unverifiedUnder65: [],
    unverifiedUnder65Meta: {},
    new: [],
    newMeta: {},
    active: [],
    strokecare:[],
    activeMeta: {},
    gAPSColorectal:[],
    gAPSColorectalMeta:{},
    gAPSBreastCancer:[],
    gAPSBreastCancerMeta:{},
    gAPSDiabeticEye:[],
    gAPSDiabeticEyeMeta:{},
    strokecareMeta: {},
	patientServices: [],
	patientServicesMeta: {},
	patientServicesOpenCharts: [],
	patientServicesOpenChartsMeta: {},
	urgentNoAnswer: [],
	urgentNoAnswerMeta: {},
    Optout: [],
    OptoutMeta: {},
    urgentAccount: [],
    urgentAccountMeta: {},
    urgentCcm: [],
    urgentCcmMeta: {},
    urgentRefill: [],
    urgentTriage:[],
    urgentRefillMeta: {},
    urgentTriageMeta:{},
	urgentCarePlan: [],
	urgentCarePlanMeta: {},
	urgentAppointment: [],
	urgentAppointmentMeta: {},
	urgentPreEnrollment: [],
	urgentPreEnrollmentMeta: {},
	urgentMips: [],
	urgentMipsMeta: {},
    urgentNurse: [],
    urgentNurseMeta: {},
    urgentITMedicalRecord:[],
    urgentITMedicalRecordMeta:{},
    urgentDischargeManagement:[],
    urgentDischargeManagementMeta:{},
    rpmThresholdAlerts: [],
    rpmThresholdAlertsMeta: {},
    rpmThresholdAlertsStale: false,
    rpmThresholdAlertsSyncedAt: null,
    selectedRpmAlertSeverityId: null,
    rpmThresholdChartContext: null,
    urgentCne: [],
    urgentCneMeta: {},
	urgentBadPhone: [],
	urgentBadPhoneMeta: {},
	urgentPoa: [],
	urgentPoaMeta: {},
	urgentRequestedInfo: [],
	urgentRequestedInfoMeta: {},
	urgentCallBack: [],
	urgentCallBackMeta: {},
	urgentRoundTwo: [],
	urgentRoundTwoMeta: {},
	urgentCopay: [],
	urgentCopayMeta: {},
	urgentDoNotCall: [],
	urgentDoNotCallMeta: {},
	urgentRemoveFromQueue: [],
	urgentRemoveFromQueueMeta: {},
	urgentProviderChange: [],
	urgentProviderChangeMeta: {},
	urgentLead: [],
	urgentLeadMeta: {},
	urgentSupport: [],
	urgentSupportMeta: {},
    records: [],
    recordsMeta: {},
    search: [],
    searchMeta: {},
    searchTerm: '',
    searchDate: '',
    noSearchResults: false,
    programType:'',
    gapsEngagementStatus:'All',
    preferredLanguage:'English',
    selectedTeam:'',
    selectedClinician:'',
    selectedTeamForAllPateints:[],
    selectedClinicianForAllPatients:[],
    selectedGeographics:[],
    selectedTimezones:[],
    allPatientsCallAttempts:[],
    myPatients: [],
	myPatientsMeta: {},
    myTeamPatients: [],
	myTeamPatientsMeta: {},
    allPatients: [],
	allPatientsMeta: {},
    allAPCMPatients: [],
	allAPCMPatientsMeta: {},
    completedChecked:true,
    showOnlyCallAttempts:false,
    reEngageFiltering:'NewUnverified',
    clinicalServiceGoal:'',
    apcmEnrollment: null,
    rpmAddonStatusId: null,
    rpmAddonStatuses: [],
    rpmDeviceTypes: [],
    selectedEligibilityLevel:'',
    selectedRpmDeviceTypeId: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ORGS_SUCCESS:
            return {
                ...state,
                organizations: action.payload,
            };
        case FETCH_LOCATIONS_SUCCESS:
            return {
                ...state,
                locations: _.sortBy(uniqByKey(action.payload.location, 'id'), 'name'),
            };

        case FETCH_QUEUE_REQUEST:
            return {
                ...state,
                noSearchResults: false,
            };
        case MYQUEUE_COUNTS_RECEIVED:{
            return {
                ...state,
                counts: action.payload.counts,
            };
        }    
        case ALLPATIENTS_COUNTS_RECEIVED: {
            return {
                ...state,
                counts: action.payload.counts,
            };
        }
        case FETCH_QUEUE_SUCCESS: {
            const {
                items,
                count,
                page,
                total_items,
                total_pages,
                program_type_counts,
                severity_counts: severityCounts,
            } = action.payload;
            const queueItems = action.queue === RPM_ALERT_QUEUE_ROUTE
                ? prepareRpmAlertQueueItems(items, state.selectedRpmAlertSeverityId)
                : items;
            const rpmHeaderTotal = action.queue === RPM_ALERT_QUEUE_ROUTE
                ? resolveRpmAlertQueueTotalItems(
                    state.selectedRpmAlertSeverityId,
                    total_items,
                    severityCounts,
                    queueItems.length
                )
                : total_items;
            const meta = {
                count,
                page,
                total_items: rpmHeaderTotal,
                total_pages,
                program_type_counts: program_type_counts || null,
                severity_counts: severityCounts || null,
            };
            const locationArray = _.filter(state.locations,(location) => {
                return location.id == action.locationId
            });
            const providers = locationArray.length >0 ? locationArray[0].provider : [];
            return {
                ...state,
                [action.queue]: queueItems,
                [`${action.queue}Meta`]: meta,
                ...(action.queue === RPM_ALERT_QUEUE_ROUTE ? {
                    rpmThresholdAlertsStale: false,
                    rpmThresholdAlertsSyncedAt: action.syncedAt,
                } : {}),
                currentQueue: action.queue,
                orgId: action.orgId,
                programType: action.programType,
                scheduledCallStatus:action.scheduledCallStatus,
                preferredLanguage: action.preferredLanguage,
                gapsEngagementStatus: action.gapsEngagementStatus,
                locationId: action.locationId,
                providerId: action.providerId,
                providers: _.sortBy(providers, 'name'),
                locations: action.orgId ? state.locations : [],
                showFilters: action.showFilters,
	            showSort: action.showSort,
                selectedTeam: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients') ? action.selectedTeam : state.selectedTeam,
                selectedTeamForAllPateints: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedTeamForAllPateints : state.selectedTeamForAllPateints,
                selectedClinician: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ?  state.selectedClinician : action.selectedTeam == 1 && 
                    (action.queue !== 'myTeamPatients') ? '' : action.selectedClinician,
                selectedClinicianForAllPatients: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedClinicianForAllPatients : state.selectedClinicianForAllPatients,
                selectedGeographics: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedGeographics : state.selectedGeographics,
                selectedTimezones: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedTimezones : state.selectedTimezones,
                allPatientsCallAttempts: (action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.allPatientsCallAttempts : state.allPatientsCallAttempts,
                callAttempts:action.callAttempts,
                completedChecked: action.completedChecked,
                showOnlyCallAttempts: action.showOnlyCallAttempts,
	            [`${action.queue}SortBy`]: action.sortBy,
                urgentType:action.urgentType,
                reEngageFiltering: (action.queue !== 'unverified' && action.queue !== 'apcmunverified' && action.queue !== 'rpmunverified')  ? state.reEngageFiltering : action.reEngageFiltering,
                clinicalServiceGoal: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients')  ? state.clinicalServiceGoal : action.clinicalServiceGoal,
                connectedCall: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients') ? state.connectedCall : action.connectedCall,
                myPatientsFlag: ( action.queue !== 'allAPCMPatients') ? state.myPatientsFlag : action.myPatientsFlag,
                patientStatus: (action.queue !== 'allAPCMPatients' ? state.patientStatus : action.patientStatus),
                apcmEnrollment: action.apcmEnrollment,
                rpmAddonStatusId: action.rpmAddonStatusId,
                selectedEligibilityLevel: action.selectedEligibilityLevel,
                selectedAPCMServiceLevel: action.selectedAPCMServiceLevel,
                levelChangePending: action.levelChangePending
            };
        }
        case FETCH_QUEUE_FAILURE: {
            if (action.queue === RPM_ALERT_QUEUE_ROUTE) {
                return {
                    ...state,
                    rpmThresholdAlertsStale: true,
                    currentQueue: action.queue,
                };
            }
            const locationIndex = state.locations.map((l) => l.id).indexOf(action.locationId);
            const providers = state.locations[locationIndex] ? state.locations[locationIndex].provider : [];
            return {
                ...state,
                [action.queue]: [],
                [`${action.queue}Meta`]: {},
                currentQueue: action.queue,
                orgId: action.orgId,
                programType: action.programType,
                scheduledCallStatus:action.scheduledCallStatus,
                preferredLanguage: action.preferredLanguage,
                locationId: action.locationId,
                providerId: action.providerId,
                providers: _.sortBy(providers, 'name'),
                locations: action.orgId ? state.locations : [],
                showFilters: action.showFilters,
	            showSort: action.showSort,
                selectedTeam:(action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients') ? action.selectedTeam : state.selectedTeam,
                selectedTeamForAllPateints:action.queue === 'allPatients' ? action.selectedTeam 
                    : state.selectedTeamForAllPateints,
                selectedClinician: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients') ? action.selectedClinician : state.selectedClinician,
                selectedClinicianForAllPatients:(action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedClinician 
                    : state.selectedClinicianForAllPatients,
                selectedGeographics:(action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedGeographics 
                    : state.selectedGeographics,  
                selectedTimezones:(action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.selectedTimezones 
                    : state.selectedTimezones,          
                allPatientsCallAttempts:(action.queue === 'allPatients' || action.queue === 'allAPCMPatients') ? action.allPatientsCallAttempts 
                    : state.allPatientsCallAttempts,         
                callAttempts:action.callAttempts,
                completedChecked: action.completedChecked,
                showOnlyCallAttempts: action.showOnlyCallAttempts,
	            [`${action.queue}SortBy`]: action.sortBy,
                urgentType:action.urgentType,
                reEngageFiltering: (action.queue !== 'unverified' && action.queue !== 'apcmunverified' && action.queue !== 'rpmunverified')  ? state.reEngageFiltering : action.reEngageFiltering,
                clinicalServiceGoal: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients')  ? state.clinicalServiceGoal : action.clinicalServiceGoal,
                connectedCall: (action.queue !== 'allPatients' && action.queue !== 'allAPCMPatients') ? state.connectedCall : action.connectedCall,
                myPatientsFlag: (action.queue !== 'allAPCMPatients') ? state.myPatientsFlag : action.myPatientsFlag,
                patientStatus: (action.queue !== 'allAPCMPatients' ? state.patientStatus : action.patientStatus),
                apcmEnrollment: action.apcmEnrollment,
                rpmAddonStatusId: action.rpmAddonStatusId,
                selectedEligibilityLevel: action.selectedEligibilityLevel,
                selectedAPCMServiceLevel: action.selectedAPCMServiceLevel,
                levelChangePending: action.levelChangePending
            };
        }
        case RPM_ADDON_STATUSES_RECEIVED:
            return {
                ...state,
                rpmAddonStatuses: action.payload,
            };
        case RPM_DEVICE_TYPES_RECEIVED:
            return {
                ...state,
                rpmDeviceTypes: action.payload,
            };
        case SET_RPM_DEVICE_TYPE_FILTER:
            return {
                ...state,
                selectedRpmDeviceTypeId: action.selectedRpmDeviceTypeId || null,
            };
        case SET_RPM_ALERT_SEVERITY_FILTER:
            return {
                ...state,
                selectedRpmAlertSeverityId: action.selectedRpmAlertSeverityId || null,
            };
        case SET_RPM_THRESHOLD_CHART_CONTEXT:
            return {
                ...state,
                rpmThresholdChartContext: action.context || null,
            };
        case CLEAR_RPM_THRESHOLD_CHART_CONTEXT:
            return {
                ...state,
                rpmThresholdChartContext: null,
            };
        case FETCH_CALL_LOG_CODES_SUCCESS:
            return {
                ...state,
                callLogCodes: action.payload,
            };
        case SEARCH_PATIENTS_SUCCESS: {
            return {
                ...state,
                search: action.payload,
                noSearchResults: action.payload.length ? false : true,
                searchTerm: action.searchTerm,
                searchDate: action.searchDate,
            };
        }
        case SEARCH_PATIENTS_FAILURE:
            return {
                ...state,
                search: [],
                noSearchResults: true,
                searchTerm: action.searchTerm,
                searchDate: action.searchDate,
            };
        case RESET_SEARCH_RESULE:
            return {
                ...state,
                search: [],
                noSearchResults: false,
                searchTerm: action.searchTerm,
                searchDate: action.searchDate,
            };
        case ACTIVE_USER_RECEIVED:
            return {
                ...state,
                selectedTeam: action.payload.team_id,
                selectedClinician:action.payload.id
            };
        case ON_TEAM_SELECTED:   
            return {
                ...state,
                selectedTeam: state.queue !== 'allPatients' ? action.payload : '',
                selectedTeamForAllPateints: action.payload,
                selectedClinician:''
            }; 
        case ON_CLINICIAN_SELECTED:   
            return {
                ...state,
                selectedClinician:  state.queue !== 'allPatients' ?action.payload : '',
                selectedClinicianForAllPatients: state.queue === 'allPatients' ? action.payload : '',
            }; 
        default:
            return state;
     }
}
